import React from 'react';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import Optout from '../Components/Optout/Optout';
import * as PersonActions from '../Actions/PersonActivityAction';

class OptoutContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showErrorPage: false,
    };
    this.updateStatus = this.updateStatus.bind(this);
  }

  componentDidMount() {
    const { location } = this.props;
    const { ref } = queryString.parse(location.search);
    if (!ref) {
      this.setState({
        showErrorPage: true,
      });
    } else {
      this.setState({
        ref,
      });
    }
  }

  updateStatus() {
    const { history } = this.props;
    const { ref } = this.state;
    PersonActions.updateConsentStatus(ref, 'Denied', history, 'OptoutSuccess');
  }

  render() {
    const { showErrorPage } = this.state;
    if (showErrorPage) {
      return <div>Invalid URL</div>;
    }
    return <Optout updateStatus={this.updateStatus} />;
  }
}

export default withRouter(OptoutContainer);
